
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("04xaX", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $auu3D = parcelRequire("auu3D");


var $eNbr2 = parcelRequire("eNbr2");

var $794I6 = parcelRequire("794I6");


var $d4eUy = parcelRequire("d4eUy");

const $3ca1b04bd37e35d3$var$MENTION_PROVIDERS = [
    'mentionProvider',
    'profilecardProvider'
];
class $3ca1b04bd37e35d3$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        const providers = (0, $4o0zT.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? $3ca1b04bd37e35d3$var$MENTION_PROVIDERS : [
            'mentionProvider',
            'profilecardProvider'
        ];
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $794I6.WithProviders), {
            providers: providers,
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        this.renderWithProvider = (providers)=>{
            const { accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, text: text, localId: localId, userType: userType, isDisabled: isDisabled, disabledTooltip: disabledTooltip, mentionNodeDataProvider: mentionNodeDataProvider } = this.props;
            const { mentionProvider: mentionProvider, profilecardProvider: profilecardProvider } = providers;
            const hasProvider = Boolean(mentionNodeDataProvider);
            const canReportMissingProvider = !hasProvider && (0, $iDrrr.fg)('platform_editor_mention_avatar_observability');
            const isAvatarEnabled = (0, $auu3D.isMentionAvatarEnabled)({
                id: id,
                userType: userType,
                hasProvider: hasProvider,
                canReportMissingProvider: canReportMissingProvider
            });
            if (isAvatarEnabled && mentionNodeDataProvider) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d4eUy.MentionWithAvatarProviders), {
                id: id,
                text: text,
                accessLevel: accessLevel,
                localId: localId,
                userType: userType,
                isDisabled: isDisabled,
                disabledTooltip: disabledTooltip,
                eventHandlers: eventHandlers,
                mentionProvider: mentionProvider,
                mentionNodeDataProvider: mentionNodeDataProvider,
                profilecardProvider: profilecardProvider
            });
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                children: [
                    canReportMissingProvider && isAvatarEnabled && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d4eUy.MissingMentionAvatarProvider), {
                        mentionKey: `${userType ?? 'DEFAULT'}:${id}`
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d4eUy.MentionWithProviders), {
                        id: id,
                        text: text,
                        accessLevel: accessLevel,
                        localId: localId,
                        userType: userType,
                        isDisabled: isDisabled,
                        disabledTooltip: disabledTooltip,
                        eventHandlers: eventHandlers,
                        mentionProvider: mentionProvider,
                        mentionNodeData: mentionNodeDataProvider && (0, $4o0zT.isExperimentEnabled)('platform_editor_mention_rovo') ? mentionNodeDataProvider.getMentionDataFromCache({
                            id: id,
                            userType: userType
                        }) : undefined,
                        profilecardProvider: profilecardProvider
                    })
                ]
            });
        };
        this.providerFactory = props.providers || new (0, $eNbr2.default)();
    }
}
module.exports["default"] = $3ca1b04bd37e35d3$export$2e2bcd8739ae039;

});

parcelRegister("auu3D", function(module, exports) {

var $cha5E = parcelRequire("cha5E");


var $4o0zT = parcelRequire("4o0zT");

const $5e9b3d37582472db$var$GENERIC_MENTION_IDS = [
    'HipChat',
    'all',
    'here'
];
function $5e9b3d37582472db$export$171ad3a6a5726ecd({ id: id, userType: userType, hasProvider: hasProvider, canReportMissingProvider: canReportMissingProvider = false }) {
    // Preserve Platform's cohort exposure, including when a provider is missing.
    const cohort = (0, $cha5E.expVal)('convo_ai_entity_hover_cards_non_hello_exp', 'hover_card_cohort', 'control');
    return (hasProvider || canReportMissingProvider) && userType !== 'SPECIAL' && !$5e9b3d37582472db$var$GENERIC_MENTION_IDS.includes(id) && (cohort === 'person' || cohort === 'all' || (0, $4o0zT.isExperimentEnabled)('platform_editor_mention_node_avatar') || (0, $4o0zT.isExperimentEnabled)('canvas_agentic_experiences_master_exp') || (0, $4o0zT.isExperimentEnabled)('platform_editor_mention_node_graphql_provider') || (userType === 'APP' || userType === 'AGENT') && (0, $4o0zT.isExperimentEnabled)('platform_editor_drop3_hexagon_agent_avatar'));
}
module.exports["isMentionAvatarEnabled"] = $5e9b3d37582472db$export$171ad3a6a5726ecd;

});

parcelRegister("d4eUy", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $4cczm = parcelRequire("4cczm");


var $5zCi6 = parcelRequire("5zCi6");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $Hhhdz = parcelRequire("Hhhdz");

const $379fc97538bbbbaa$var$GENERIC_USER_IDS = [
    'HipChat',
    'all',
    'here'
];
const $379fc97538bbbbaa$var$useAvatarFailureReporter = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const createEventRef = (0, $cozmU.useRef)(createAnalyticsEvent);
    createEventRef.current = createAnalyticsEvent;
    return (0, $cozmU.useCallback)((reason)=>{
        if ((0, $iDrrr.fg)('platform_editor_mention_avatar_observability')) createEventRef.current({
            action: 'failed',
            actionSubject: 'mentionAvatar',
            eventType: 'operational',
            attributes: {
                componentName: 'mention',
                reason: reason,
                surface: 'renderer'
            }
        }).fire((0, $4cczm.ELEMENTS_CHANNEL));
    }, []);
};
const $379fc97538bbbbaa$export$e92099834a099489 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { mentionKey: mentionKey } = t0;
    const reportFailure = $379fc97538bbbbaa$var$useAvatarFailureReporter();
    const reportedKey = (0, $cozmU.useRef)();
    let t1;
    let t2;
    if ($[0] !== mentionKey || $[1] !== reportFailure) {
        t1 = ()=>{
            if (reportedKey.current !== mentionKey) {
                reportedKey.current = mentionKey;
                reportFailure("missing_provider");
            }
        };
        t2 = [
            mentionKey,
            reportFailure
        ];
        $[0] = mentionKey;
        $[1] = reportFailure;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ mentionKey: mentionKey })=>{
    const reportFailure = $379fc97538bbbbaa$var$useAvatarFailureReporter();
    const reportedKey = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        if (reportedKey.current !== mentionKey) {
            reportedKey.current = mentionKey;
            reportFailure('missing_provider');
        }
    }, [
        mentionKey,
        reportFailure
    ]);
    return null;
};
const $379fc97538bbbbaa$var$useMentionNodeData = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { id: id, mentionNodeDataProvider: mentionNodeDataProvider, userType: userType } = t0;
    const reportFailure = $379fc97538bbbbaa$var$useAvatarFailureReporter();
    const reportedResolution = (0, $cozmU.useRef)();
    let t1;
    if ($[0] !== id || $[1] !== userType) {
        t1 = {
            id: id,
            userType: userType
        };
        $[0] = id;
        $[1] = userType;
        $[2] = t1;
    } else t1 = $[2];
    const mention = t1;
    const mentionKey = `${userType ?? "DEFAULT"}:${id}`;
    let t2;
    if ($[3] !== mention || $[4] !== mentionNodeDataProvider) {
        t2 = mentionNodeDataProvider.getMentionDataFromCache(mention);
        $[3] = mention;
        $[4] = mentionNodeDataProvider;
        $[5] = t2;
    } else t2 = $[5];
    const synchronousData = t2;
    let t3;
    if ($[6] !== mentionKey || $[7] !== synchronousData) {
        t3 = ()=>({
                data: synchronousData,
                key: mentionKey
            });
        $[6] = mentionKey;
        $[7] = synchronousData;
        $[8] = t3;
    } else t3 = $[8];
    const [state, setState] = (0, $cozmU.useState)(t3);
    const data = state.key === mentionKey ? state.data ?? synchronousData : synchronousData;
    let t4;
    let t5;
    if ($[9] !== mention || $[10] !== mentionKey || $[11] !== mentionNodeDataProvider || $[12] !== reportFailure || $[13] !== synchronousData) {
        t4 = ()=>{
            const reportResolution = (data_0, error)=>{
                if (!error && (!data_0 || data_0.avatarUrl)) return;
                if (reportedResolution.current?.mention === mention && reportedResolution.current.provider === mentionNodeDataProvider) return;
                reportedResolution.current = {
                    mention: mention,
                    provider: mentionNodeDataProvider
                };
                if (error) reportFailure("provider_failed");
                else if (data_0 && !data_0.avatarUrl) reportFailure("missing_avatar_url");
            };
            if (synchronousData) {
                reportResolution(synchronousData);
                return;
            }
            let isActive = true;
            mentionNodeDataProvider.getMentionData(mention, (payload)=>{
                if (isActive) {
                    reportResolution(payload.data, payload.error);
                    if (payload.data) setState({
                        data: payload.data,
                        key: mentionKey
                    });
                }
            });
            return ()=>{
                isActive = false;
            };
        };
        t5 = [
            mention,
            mentionKey,
            mentionNodeDataProvider,
            synchronousData,
            reportFailure
        ];
        $[9] = mention;
        $[10] = mentionKey;
        $[11] = mentionNodeDataProvider;
        $[12] = reportFailure;
        $[13] = synchronousData;
        $[14] = t4;
        $[15] = t5;
    } else {
        t4 = $[14];
        t5 = $[15];
    }
    (0, $cozmU.useEffect)(t4, t5);
    return data;
} : ({ id: id, mentionNodeDataProvider: mentionNodeDataProvider, userType: userType })=>{
    const reportFailure = $379fc97538bbbbaa$var$useAvatarFailureReporter();
    const reportedResolution = (0, $cozmU.useRef)();
    const mention = (0, $cozmU.useMemo)(()=>({
            id: id,
            userType: userType
        }), [
        id,
        userType
    ]);
    const mentionKey = `${userType ?? 'DEFAULT'}:${id}`;
    const synchronousData = (0, $cozmU.useMemo)(()=>mentionNodeDataProvider.getMentionDataFromCache(mention), [
        mention,
        mentionNodeDataProvider
    ]);
    const [state, setState] = (0, $cozmU.useState)(()=>({
            data: synchronousData,
            key: mentionKey
        }));
    const data = state.key === mentionKey ? state.data ?? synchronousData : synchronousData;
    (0, $cozmU.useEffect)(()=>{
        const reportResolution = (data_0, error)=>{
            if (!error && (!data_0 || data_0.avatarUrl)) return;
            if (reportedResolution.current?.mention === mention && reportedResolution.current.provider === mentionNodeDataProvider) return;
            reportedResolution.current = {
                mention: mention,
                provider: mentionNodeDataProvider
            };
            if (error) reportFailure('provider_failed');
            else if (data_0 && !data_0.avatarUrl) reportFailure('missing_avatar_url');
        };
        if (synchronousData) {
            reportResolution(synchronousData);
            return;
        }
        let isActive = true;
        mentionNodeDataProvider.getMentionData(mention, (payload)=>{
            if (isActive) {
                reportResolution(payload.data, payload.error);
                if (payload.data) setState({
                    data: payload.data,
                    key: mentionKey
                });
            }
        });
        return ()=>{
            isActive = false;
        };
    }, [
        mention,
        mentionKey,
        mentionNodeDataProvider,
        synchronousData,
        reportFailure
    ]);
    return data;
};
const $379fc97538bbbbaa$export$cd21803c89efe790 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ accessLevel: accessLevel, disabledTooltip: disabledTooltip, eventHandlers: eventHandlers, id: id, isDisabled: isDisabled, mentionNodeData: mentionNodeData, mentionProvider: mentionProvider, profilecardProvider: profilecardProviderResolver, renderAvatarSlot: renderAvatarSlot = false, text: text, localId: localId, userType: userType })=>{
    const [profilecardProvider, setProfilecardProvider] = (0, $cozmU.useState)(null);
    const [isRovoChat, setIsRovoChat] = (0, $cozmU.useState)((0, $4o0zT.isExperimentEnabled)('platform_editor_mention_rovo') && Boolean(mentionNodeData?.isRovoChat));
    const mountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $cozmU.useLayoutEffect)(()=>{
        // We are not using async/await here to avoid having an intermediate Promise
        // introduced by the transpiler.
        // This will allow consumer to use a SynchronousPromise.resolve and avoid useless
        // rerendering
        profilecardProviderResolver?.then((result)=>{
            if (mountedRef.current) setProfilecardProvider(result);
        }).catch(()=>{
            if (mountedRef.current) setProfilecardProvider(null);
        });
    }, [
        profilecardProviderResolver
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (mentionNodeData?.isRovoChat) {
            setIsRovoChat((0, $4o0zT.isExperimentEnabled)('platform_editor_mention_rovo'));
            return;
        }
        if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_mention_rovo') || !mentionProvider) {
            setIsRovoChat(false);
            return;
        }
        let isActive = true;
        const resolveRovoChatIdentity = async ()=>{
            try {
                const provider = await mentionProvider;
                const identityAccountId = await provider.getRovoChatAgentIdentityAccountId?.();
                if (isActive) setIsRovoChat(identityAccountId !== undefined && identityAccountId === id);
            } catch  {
                if (isActive) setIsRovoChat(false);
            }
        };
        resolveRovoChatIdentity();
        return ()=>{
            isActive = false;
        };
    }, [
        id,
        mentionNodeData?.isRovoChat,
        mentionProvider
    ]);
    const MentionComponent = profilecardProvider && profilecardProviderResolver && $379fc97538bbbbaa$var$GENERIC_USER_IDS.indexOf(id) === -1 ? (0, $Hhhdz.default) : (0, $5zCi6.default);
    const mentionUserType = userType === 'AGENT' ? 'APP' : userType;
    const ssrPlaceholderId = `mention-${id}`;
    // A disabled mention is non-interactive, so it bypasses the profile-card
    // wrapper and renders the disabled resourced mention directly.
    if (isDisabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5zCi6.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        userType: mentionUserType,
        mentionProvider: mentionProvider,
        appType: mentionNodeData?.appType,
        avatarUrl: mentionNodeData?.avatarUrl,
        isAvatarImagePreShaped: mentionNodeData?.isAvatarImagePreShaped,
        isDisabled: true,
        disabledTooltip: disabledTooltip,
        onClick: eventHandlers?.onClick,
        onMouseEnter: eventHandlers?.onMouseEnter,
        onMouseLeave: eventHandlers?.onMouseLeave,
        renderAvatarSlot: renderAvatarSlot,
        ssrPlaceholderId: ssrPlaceholderId,
        isRovoChat: isRovoChat
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)(MentionComponent, {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        userType: mentionUserType,
        mentionProvider: mentionProvider,
        appType: mentionNodeData?.appType,
        avatarUrl: mentionNodeData?.avatarUrl,
        isAvatarImagePreShaped: mentionNodeData?.isAvatarImagePreShaped,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        profilecardProvider: profilecardProvider,
        onClick: eventHandlers?.onClick,
        onMouseEnter: eventHandlers?.onMouseEnter,
        onMouseLeave: eventHandlers?.onMouseLeave,
        renderAvatarSlot: renderAvatarSlot,
        ssrPlaceholderId: ssrPlaceholderId,
        isRovoChat: isRovoChat
    });
});
const $379fc97538bbbbaa$export$6a371f6a27c8a54b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    let id;
    let mentionNodeDataProvider;
    let props;
    let userType;
    if ($[0] !== t0) {
        ({ id: id, mentionNodeDataProvider: mentionNodeDataProvider, userType: userType, ...props } = t0);
        $[0] = t0;
        $[1] = id;
        $[2] = mentionNodeDataProvider;
        $[3] = props;
        $[4] = userType;
    } else {
        id = $[1];
        mentionNodeDataProvider = $[2];
        props = $[3];
        userType = $[4];
    }
    let t1;
    if ($[5] !== id || $[6] !== mentionNodeDataProvider || $[7] !== userType) {
        t1 = {
            id: id,
            mentionNodeDataProvider: mentionNodeDataProvider,
            userType: userType
        };
        $[5] = id;
        $[6] = mentionNodeDataProvider;
        $[7] = userType;
        $[8] = t1;
    } else t1 = $[8];
    const mentionNodeData = $379fc97538bbbbaa$var$useMentionNodeData(t1);
    let t2;
    if ($[9] !== id || $[10] !== mentionNodeData || $[11] !== props || $[12] !== userType) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($379fc97538bbbbaa$export$cd21803c89efe790, {
            ...props,
            id: id,
            mentionNodeData: mentionNodeData,
            renderAvatarSlot: true,
            userType: userType
        });
        $[9] = id;
        $[10] = mentionNodeData;
        $[11] = props;
        $[12] = userType;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
} : ({ id: id, mentionNodeDataProvider: mentionNodeDataProvider, userType: userType, ...props })=>{
    const mentionNodeData = $379fc97538bbbbaa$var$useMentionNodeData({
        id: id,
        mentionNodeDataProvider: mentionNodeDataProvider,
        userType: userType
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($379fc97538bbbbaa$export$cd21803c89efe790, {
        ...props,
        id: id,
        mentionNodeData: mentionNodeData,
        renderAvatarSlot: true,
        userType: userType
    });
});
module.exports["MissingMentionAvatarProvider"] = $379fc97538bbbbaa$export$e92099834a099489;
module.exports["MentionWithProviders"] = $379fc97538bbbbaa$export$cd21803c89efe790;
module.exports["MentionWithAvatarProviders"] = $379fc97538bbbbaa$export$6a371f6a27c8a54b;

});

parcelRegister("5zCi6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cRgxl = parcelRequire("cRgxl");


var $cLgZp = parcelRequire("cLgZp");


var $caelp = parcelRequire("caelp");


var $2SUNK = parcelRequire("2SUNK");


var $12QCz = parcelRequire("12QCz");

var $4cczm = parcelRequire("4cczm");

class $9a3220735be5ff34$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        this.handleMentionProvider(this.props);
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { props: props } = this;
        if (props.id !== nextProps.id || props.mentionProvider !== nextProps.mentionProvider) this.handleMentionProvider(nextProps);
    }
    setStateSafely(newState) {
        if (!this._isMounted) {
            (0, $2SUNK.default)('[ResourcedMention]: cannot setState when component is unmounted.');
            return;
        }
        this.setState(newState);
    }
    processName(name) {
        let mentionName;
        switch(name.status){
            case (0, $caelp.MentionNameStatus).OK:
                mentionName = name.name || '';
                break;
            case (0, $caelp.MentionNameStatus).SERVICE_ERROR:
            case (0, $caelp.MentionNameStatus).UNKNOWN:
            default:
                mentionName = (0, $4cczm.UNKNOWN_USER_ID);
                break;
        }
        return `@${mentionName}`;
    }
    render() {
        const { props: props, state: state } = this;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $12QCz.default), {
            id: props.id,
            text: props.text || state.resolvedMentionName || '',
            isHighlighted: state.isHighlighted,
            isDisabled: props.isDisabled,
            disabledTooltip: props.disabledTooltip,
            accessLevel: props.accessLevel,
            appType: props.appType,
            avatarUrl: props.avatarUrl,
            isAvatarImagePreShaped: props.isAvatarImagePreShaped,
            localId: props.localId,
            userType: props.userType,
            onClick: props.onClick,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave,
            renderAvatarSlot: props.renderAvatarSlot,
            isRovoChat: props.isRovoChat,
            ssrPlaceholderId: props.ssrPlaceholderId
        });
    }
    constructor(_props){
        super(_props);
        this._isMounted = void 0;
        this.handleMentionProvider = (props)=>{
            const { id: id, mentionProvider: mentionProvider, text: text } = props;
            if (mentionProvider) mentionProvider.then((provider)=>{
                const newState = {
                    isHighlighted: provider.shouldHighlightMention({
                        id: id
                    })
                };
                if (!text && (0, $cRgxl.isResolvingMentionProvider)(provider)) {
                    const nameDetail = provider.resolveMentionName(id);
                    if ((0, $cLgZp.isPromise)(nameDetail)) nameDetail.then((nameDetailResult)=>{
                        this.setStateSafely({
                            resolvedMentionName: this.processName(nameDetailResult)
                        });
                    });
                    else newState.resolvedMentionName = this.processName(nameDetail);
                }
                this.setStateSafely(newState);
            }).catch(()=>{
                this.setStateSafely({
                    isHighlighted: false
                });
            });
            else this.setStateSafely({
                isHighlighted: false
            });
        };
        this._isMounted = false;
        this.state = {
            isHighlighted: false
        };
    }
}
module.exports["default"] = $9a3220735be5ff34$export$2e2bcd8739ae039;

});

parcelRegister("Hhhdz", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $eRn3r = parcelRequire("eRn3r");


var $5zCi6 = parcelRequire("5zCi6");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $l8Rhq = parcelRequire("l8Rhq");


var $hSs5g = parcelRequire("hSs5g");


var $hMCZS = parcelRequire("hMCZS");


var $ieeJu = parcelRequire("ieeJu");


// Lazy-loaded so the agent profile card chunk (and its `@atlaskit/rovo-agent-components`
// dependency) stays off the critical path — it is only fetched when an agent mention
// (`userType === 'APP'`) actually renders, never for person mentions.
const $e56bc9dce22ad0d3$var$loadAgentProfileCardTrigger = ()=>(parcelRequire("8WrgS")).then((mod)=>mod.AgentProfileCardTrigger);

const $e56bc9dce22ad0d3$var$AgentProfileCardTriggerLazy = (0, $eRn3r.lazy)(()=>(parcelRequire("8WrgS")).then((mod)=>mod.AgentProfileCardTrigger));
$e56bc9dce22ad0d3$var$AgentProfileCardTriggerLazy.displayName = 'lazy(AgentProfileCardTrigger)';
const $e56bc9dce22ad0d3$var$AgentProfileCardTriggerLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "k8SQe",
    name: "AgentProfileCardTriggerLoadable",
    loader: $e56bc9dce22ad0d3$var$loadAgentProfileCardTrigger,
    loading: ()=>null
});
const $e56bc9dce22ad0d3$var$AgentProfileCardTrigger = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $4o0zT.isExperimentEnabled)("platform_editor_loosely_lazy_migration") ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eRn3r.LazySuspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($e56bc9dce22ad0d3$var$AgentProfileCardTriggerLazy, {
                ...props
            })
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)($e56bc9dce22ad0d3$var$AgentProfileCardTriggerLoadable, {
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eRn3r.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($e56bc9dce22ad0d3$var$AgentProfileCardTriggerLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $8aG6j.jsx)($e56bc9dce22ad0d3$var$AgentProfileCardTriggerLoadable, {
        ...props
    });
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e56bc9dce22ad0d3$var$AT_PREFIX_REGEX = /^@/;
/**
 * Renders a mention chip wrapped in the appropriate profile card trigger.
 * 1. Agent mentions (`userType === 'APP'`, behind the `rovo_chat_mention_agents` experiment) open the Rovo agent profile card on click.
 * 2. Otherwise renders the person profile card (either via the provider's `renderUserMentionCard`/link fallback or the default user `ProfileCardTrigger`).
 */ const $e56bc9dce22ad0d3$var$MentionWithProfileCard = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MentionWithProfileCard(t0) {
    const $ = (0, $bDgLe.c)(61);
    const { autoFocus: autoFocus, id: id, text: text, accessLevel: accessLevel, appType: appType, avatarUrl: avatarUrl, isAvatarImagePreShaped: isAvatarImagePreShaped, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, renderAvatarSlot: renderAvatarSlot, isRovoChat: isRovoChat, localId: localId, ssrPlaceholderId: ssrPlaceholderId, userType: userType } = t0;
    const { cloudId: cloudId, renderAgentMentionCard: renderAgentMentionCard, renderUserMentionCard: renderUserMentionCard, resourceClient: resourceClient } = profilecardProvider;
    let t1;
    if ($[0] !== accessLevel || $[1] !== id || $[2] !== profilecardProvider || $[3] !== text) {
        t1 = profilecardProvider.getActions(id, text, accessLevel);
        $[0] = accessLevel;
        $[1] = id;
        $[2] = profilecardProvider;
        $[3] = text;
        $[4] = t1;
    } else t1 = $[4];
    const actions = t1;
    let t2;
    if ($[5] !== accessLevel || $[6] !== appType || $[7] !== avatarUrl || $[8] !== id || $[9] !== isAvatarImagePreShaped || $[10] !== isRovoChat || $[11] !== localId || $[12] !== mentionProvider || $[13] !== onClick || $[14] !== onMouseEnter || $[15] !== onMouseLeave || $[16] !== renderAvatarSlot || $[17] !== ssrPlaceholderId || $[18] !== text || $[19] !== userType) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5zCi6.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            appType: appType,
            avatarUrl: avatarUrl,
            isAvatarImagePreShaped: isAvatarImagePreShaped,
            localId: localId,
            userType: userType,
            mentionProvider: mentionProvider,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            renderAvatarSlot: renderAvatarSlot,
            isRovoChat: isRovoChat,
            ssrPlaceholderId: ssrPlaceholderId
        });
        $[5] = accessLevel;
        $[6] = appType;
        $[7] = avatarUrl;
        $[8] = id;
        $[9] = isAvatarImagePreShaped;
        $[10] = isRovoChat;
        $[11] = localId;
        $[12] = mentionProvider;
        $[13] = onClick;
        $[14] = onMouseEnter;
        $[15] = onMouseLeave;
        $[16] = renderAvatarSlot;
        $[17] = ssrPlaceholderId;
        $[18] = text;
        $[19] = userType;
        $[20] = t2;
    } else t2 = $[20];
    const mention = t2;
    if (userType === "APP" && cloudId && (0, $4o0zT.isExperimentEnabled)("rovo_chat_mention_agents")) {
        if (renderAgentMentionCard) {
            let t3;
            if ($[21] !== cloudId || $[22] !== id || $[23] !== mention || $[24] !== renderAgentMentionCard) {
                t3 = renderAgentMentionCard({
                    accountId: id,
                    children: mention,
                    cloudId: cloudId
                });
                $[21] = cloudId;
                $[22] = id;
                $[23] = mention;
                $[24] = renderAgentMentionCard;
                $[25] = t3;
            } else t3 = $[25];
            let t4;
            if ($[26] !== t3) {
                t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                    children: t3
                });
                $[26] = t3;
                $[27] = t4;
            } else t4 = $[27];
            return t4;
        }
        let t3;
        if ($[28] !== cloudId || $[29] !== id || $[30] !== mention || $[31] !== resourceClient) {
            t3 = /*#__PURE__*/ (0, $8aG6j.jsx)($e56bc9dce22ad0d3$var$AgentProfileCardTrigger, {
                agentId: id,
                agentIdType: (0, $4o0zT.isExperimentEnabled)("platform_editor_comment_mention_card_fixes") ? "identity" : undefined,
                cloudId: cloudId,
                resourceClient: resourceClient,
                trigger: "click",
                children: mention
            });
            $[28] = cloudId;
            $[29] = id;
            $[30] = mention;
            $[31] = resourceClient;
            $[32] = t3;
        } else t3 = $[32];
        return t3;
    }
    if ((0, $iDrrr.fg)("people-teams_migrate-user-profile-card") || (0, $4o0zT.isExperimentEnabled)("pt_user_profile_card_migration_exp")) {
        if (renderUserMentionCard) {
            let t3;
            if ($[33] !== cloudId || $[34] !== id || $[35] !== localId || $[36] !== mention || $[37] !== renderUserMentionCard || $[38] !== text) {
                const prefilledProfileData = {
                    accountId: id,
                    name: text.replace($e56bc9dce22ad0d3$var$AT_PREFIX_REGEX, "")
                };
                t3 = renderUserMentionCard({
                    userId: id,
                    cloudId: cloudId,
                    children: mention,
                    localId: localId,
                    prefilledProfileData: prefilledProfileData
                });
                $[33] = cloudId;
                $[34] = id;
                $[35] = localId;
                $[36] = mention;
                $[37] = renderUserMentionCard;
                $[38] = text;
                $[39] = t3;
            } else t3 = $[39];
            let t4;
            if ($[40] !== t3) {
                t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                    children: t3
                });
                $[40] = t3;
                $[41] = t4;
            } else t4 = $[41];
            return t4;
        }
        let t3;
        if ($[42] !== cloudId || $[43] !== id) {
            t3 = (0, $hMCZS.navigateToTeamsApp)({
                type: "USER",
                payload: {
                    userId: id
                },
                cloudId: cloudId
            });
            $[42] = cloudId;
            $[43] = id;
            $[44] = t3;
        } else t3 = $[44];
        const { href: href, target: target } = t3;
        let t4;
        if ($[45] !== href || $[46] !== mention || $[47] !== target) {
            t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l8Rhq.Anchor), {
                href: href,
                target: target,
                rel: "noopener noreferrer",
                testId: "mention-with-profilecard-link-fallback",
                children: mention
            });
            $[45] = href;
            $[46] = mention;
            $[47] = target;
            $[48] = t4;
        } else t4 = $[48];
        return t4;
    }
    let t3;
    if ($[49] !== text) {
        t3 = text.replace($e56bc9dce22ad0d3$var$AT_PREFIX_REGEX, "");
        $[49] = text;
        $[50] = t3;
    } else t3 = $[50];
    let t4;
    if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $ieeJu.expValEquals)("editor_a11y_7152_profile_card_tab_order", "isEnabled", true);
        $[51] = t4;
    } else t4 = $[51];
    let t5;
    if ($[52] !== actions || $[53] !== autoFocus || $[54] !== cloudId || $[55] !== id || $[56] !== mention || $[57] !== resourceClient || $[58] !== ssrPlaceholderId || $[59] !== t3) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hSs5g.default), {
            autoFocus: autoFocus,
            cloudId: cloudId,
            userId: id,
            resourceClient: resourceClient,
            actions: actions,
            trigger: "click",
            position: "bottom-end",
            testId: "mention-with-profilecard-trigger",
            ariaLabel: t3,
            ssrPlaceholderId: ssrPlaceholderId,
            isRenderedInPortal: t4,
            children: mention
        });
        $[52] = actions;
        $[53] = autoFocus;
        $[54] = cloudId;
        $[55] = id;
        $[56] = mention;
        $[57] = resourceClient;
        $[58] = ssrPlaceholderId;
        $[59] = t3;
        $[60] = t5;
    } else t5 = $[60];
    return t5;
} : function MentionWithProfileCard({ autoFocus: autoFocus, id: id, text: text, accessLevel: accessLevel, appType: appType, avatarUrl: avatarUrl, isAvatarImagePreShaped: isAvatarImagePreShaped, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, renderAvatarSlot: renderAvatarSlot, isRovoChat: isRovoChat, localId: localId, ssrPlaceholderId: ssrPlaceholderId, userType: userType }) {
    const { cloudId: cloudId, renderAgentMentionCard: renderAgentMentionCard, renderUserMentionCard: renderUserMentionCard, resourceClient: resourceClient } = profilecardProvider;
    const actions = (0, $cozmU.useMemo)(()=>profilecardProvider.getActions(id, text, accessLevel), [
        accessLevel,
        id,
        profilecardProvider,
        text
    ]);
    const mention = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5zCi6.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        appType: appType,
        avatarUrl: avatarUrl,
        isAvatarImagePreShaped: isAvatarImagePreShaped,
        localId: localId,
        userType: userType,
        mentionProvider: mentionProvider,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        renderAvatarSlot: renderAvatarSlot,
        isRovoChat: isRovoChat,
        ssrPlaceholderId: ssrPlaceholderId
    });
    // Agent mentions (userType 'APP') open the Rovo agent profile card on click.
    if (userType === 'APP' && cloudId && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents')) {
        if (renderAgentMentionCard) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: renderAgentMentionCard({
                accountId: id,
                children: mention,
                cloudId: cloudId
            })
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)($e56bc9dce22ad0d3$var$AgentProfileCardTrigger, {
            agentId: id,
            agentIdType: (0, $4o0zT.isExperimentEnabled)('platform_editor_comment_mention_card_fixes') ? 'identity' : undefined,
            cloudId: cloudId,
            resourceClient: resourceClient,
            trigger: "click",
            children: mention
        });
    }
    if ((0, $iDrrr.fg)('people-teams_migrate-user-profile-card') || (0, $4o0zT.isExperimentEnabled)('pt_user_profile_card_migration_exp')) {
        if (renderUserMentionCard) {
            const prefilledProfileData = {
                accountId: id,
                name: text.replace($e56bc9dce22ad0d3$var$AT_PREFIX_REGEX, '')
            };
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                children: renderUserMentionCard({
                    userId: id,
                    cloudId: cloudId,
                    children: mention,
                    localId: localId,
                    prefilledProfileData: prefilledProfileData
                })
            });
        }
        const { href: href, target: target } = (0, $hMCZS.navigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: id
            },
            cloudId: cloudId
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $l8Rhq.Anchor), {
            href: href,
            target: target,
            rel: "noopener noreferrer",
            testId: "mention-with-profilecard-link-fallback",
            children: mention
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hSs5g.default), {
        autoFocus: autoFocus,
        cloudId: cloudId,
        userId: id,
        resourceClient: resourceClient,
        actions: actions,
        trigger: "click",
        position: "bottom-end",
        testId: "mention-with-profilecard-trigger",
        ariaLabel: text.replace($e56bc9dce22ad0d3$var$AT_PREFIX_REGEX, ''),
        ssrPlaceholderId: ssrPlaceholderId,
        isRenderedInPortal: (0, $ieeJu.expValEquals)('editor_a11y_7152_profile_card_tab_order', 'isEnabled', true),
        children: mention
    });
};
var $e56bc9dce22ad0d3$export$2e2bcd8739ae039 = $e56bc9dce22ad0d3$var$MentionWithProfileCard;
module.exports["default"] = $e56bc9dce22ad0d3$export$2e2bcd8739ae039;

});

parcelRegister("8WrgS", function(module, exports) {

let $6828e500cc16d59b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6828e500cc16d59b$var$load("cyTuQ").then(()=>parcelRequire('eKpjD'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});


//# sourceMappingURL=mention.17539d9e.js.map
